import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Button from '@material-ui/core/Button';
import { USER_TYPES, CALLCENTER_TYPES, AREA_MANAGER_TYPES, NML_TYPES } from "../../constants/Systems";
import IntlMessages from "util/IntlMessages";
import CustomScrollbars from "util/CustomScrollbars";
import {
	isDealerPermissionTicketServiceView,
	isDealerPermissionTicketShowroomView,
	isDealerPermissionGeneralReport,
	isDealerPermissionManagementReport
} from "../../util/authUtil";

class SidenavContent extends Component {

	componentDidMount() {
		const { history } = this.props;
		const that = this;
		const pathname = `${history.location.pathname}`; // get current path
		console.log(pathname);
		const menuLi = document.getElementsByClassName("menu");
		for (let i = 0; i < menuLi.length; i++) {
			menuLi[i].onclick = function (event) {
				for (let j = 0; j < menuLi.length; j++) {
					const parentLi = that.closest(this, "li");
					if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains("open"))) {
						menuLi[j].classList.remove("open");
					}
				}
				this.classList.toggle("open");
			};
		}

		const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
		try {
			const activeNav = this.closest(activeLi, "ul"); // select closest ul
			if (activeNav.classList.contains("sub-menu")) {
				this.closest(activeNav, "li").classList.add("open");
			} else {
				this.closest(activeLi, "li").classList.add("open");
			}
		} catch (error) { }
	}

	componentDidUpdate() {
		const { history } = this.props;
		const that = this;
		const pathname = `${history.location.pathname}`; // get current path

		const menuLi = document.getElementsByClassName("menu");
		for (let i = 0; i < menuLi.length; i++) {
			menuLi[i].onclick = function (event) {
				for (let j = 0; j < menuLi.length; j++) {
					const parentLi = that.closest(this, "li");
					if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains("open"))) {
						menuLi[j].classList.remove("open");
					}
				}
				this.classList.toggle("open");
			};
		}

		const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
		try {
			const activeNav = this.closest(activeLi, "ul"); // select closest ul
			if (activeNav.classList.contains("sub-menu")) {
				this.closest(activeNav, "li").classList.add("open");
			} else {
				this.closest(activeLi, "li").classList.add("open");
			}
		} catch (error) { }
	}

	closest(el, selector) {
		try {
			let matchesFn;
			// find vendor prefix
			["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"].some(function (
				fn
			) {
				if (typeof document.body[fn] == "function") {
					matchesFn = fn;
					return true;
				}
				return false;
			});

			let parent;

			// traverse parents
			while (el) {
				parent = el.parentElement;
				if (parent && parent[matchesFn](selector)) {
					return parent;
				}
				el = parent;
			}
		} catch (e) { }

		return null;
	}

	render() {
		const { authUser } = this.props;

		return (
			<CustomScrollbars className=" scrollbar">
				<ul className="nav-menu">
					<li className="menu no-arrow">
						<NavLink to="/app/main">
							<i className="zmdi zmdi-home zmdi-hc-fw" />
							<span className="nav-text">
								<IntlMessages id="main" />
							</span>
						</NavLink>
					</li>
				</ul>
				{authUser && CALLCENTER_TYPES.includes(authUser.type) && (
					<ul className="nav-menu">
						<li className="menu">
							<li className="nav-header mt-0" style={{ cursor: 'pointer', backgroundColor: '#c61633', color: "#FFF", fontSize: "12px" }} >
								<IntlMessages id="ticket.source.callcenter.new" />
							</li>
							<ul className="sub-menu">
								<li className="menu no-arrow">
									<NavLink to="/app/ticket/callcenter/showroom/add">
										<i className="zmdi zmdi-car zmdi-hc-fw" />
										<span className="nav-text">
											<IntlMessages id="ticket.source.callcenter.new.showroom" />
										</span>
									</NavLink>
								</li>
								<li className="menu no-arrow">
									<NavLink to="/app/ticket/callcenter/service/add">
										<i className="zmdi zmdi-settings zmdi-hc-fw" />
										<span className="nav-text">
											<IntlMessages id="ticket.source.callcenter.new.service" />
										</span>
									</NavLink>
								</li>
							</ul>
						</li>
					</ul>
				)}

				{authUser && (USER_TYPES.includes(authUser.type) ||
					CALLCENTER_TYPES.includes(authUser.type) ||
					AREA_MANAGER_TYPES.includes(authUser.type) ||
					isDealerPermissionTicketShowroomView(authUser) ||
					isDealerPermissionTicketServiceView(authUser)) && (
						<ul className="nav-menu" style={{ backgroundColor: '#000000' }} >
							<li className="menu">
								<ul>
									<li className="nav-header mt-0" style={{ cursor: 'pointer', backgroundColor: '#c9364a', color: "#FFF", fontSize: "12px" }} >
										<span className="nav-text"><IntlMessages id="ticket.source.survey" /></span>
									</li>
								</ul>
								<ul className="sub-menu">
									{authUser && (USER_TYPES.includes(authUser.type) || isDealerPermissionTicketShowroomView(authUser)
										|| CALLCENTER_TYPES.includes(authUser.type) || (AREA_MANAGER_TYPES.includes(authUser.type) && authUser.group.showroom)
									) && (
											<li >
												<NavLink to="/app/ticket/survey/showroom">
													<i className="zmdi zmdi-car zmdi-hc-fw" />
													<span className="nav-text">
														<IntlMessages id="ticket.type.showroom" />
													</span>
												</NavLink>
											</li>
										)}
									{authUser && (USER_TYPES.includes(authUser.type) || (AREA_MANAGER_TYPES.includes(authUser.type) && authUser.group.showroom)) && (
										<li>
											<NavLink to="/app/ticket/survey/report/status/showroom">
												<i className="zmdi zmdi-file-text zmdi-hc-fw" />
												<span >
													<IntlMessages id="ticket.report.status.type.showroom" />
												</span>
											</NavLink>
										</li>
									)}
									{authUser && (USER_TYPES.includes(authUser.type) || (AREA_MANAGER_TYPES.includes(authUser.type) && authUser.group.showroom)) && (
										<li className="menu no-arrow">
											<NavLink to="/app/ticket/survey/report/responserate/showroom">
												<i className="zmdi zmdi-file-text zmdi-hc-fw" />
												<span className="nav-text">
													<IntlMessages id="ticket.report.responserate.type.showroom" />
												</span>
											</NavLink>
										</li>
									)}
									{authUser && (USER_TYPES.includes(authUser.type) || isDealerPermissionTicketServiceView(authUser)
										|| CALLCENTER_TYPES.includes(authUser.type) || (AREA_MANAGER_TYPES.includes(authUser.type) && authUser.group.service)
									) && (
											<li className="menu no-arrow">
												<NavLink to="/app/ticket/survey/service">
													<i className="zmdi zmdi-settings zmdi-hc-fw" />
													<span className="nav-text">
														<IntlMessages id="ticket.type.service" />
													</span>
												</NavLink>
											</li>
										)}
									{authUser && (USER_TYPES.includes(authUser.type) || (AREA_MANAGER_TYPES.includes(authUser.type) && authUser.group.service)) && (
										<li className="menu no-arrow">
											<NavLink to="/app/ticket/survey/report/status/service">
												<i className="zmdi zmdi-file-text zmdi-hc-fw" />
												<span className="nav-text">
													<IntlMessages id="ticket.report.status.type.service" />
												</span>
											</NavLink>
										</li>
									)}
									{authUser && (USER_TYPES.includes(authUser.type) || (AREA_MANAGER_TYPES.includes(authUser.type) && authUser.group.service)) && (
										<li className="menu no-arrow">
											<NavLink to="/app/ticket/survey/report/responserate/service">
												<i className="zmdi zmdi-file-text zmdi-hc-fw" />
												<span className="nav-text">
													<IntlMessages id="ticket.report.responserate.type.service" />
												</span>
											</NavLink>
										</li>
									)}
								</ul>
							</li>
						</ul>
					)}

				{false && authUser && (USER_TYPES.includes(authUser.type) ||
					isDealerPermissionTicketShowroomView(authUser) ||
					isDealerPermissionTicketServiceView(authUser)) && (
						<ul className="nav-menu" style={{ backgroundColor: "#232323" }}  >
							<li className="menu">
								<ul>
									<li className="nav-header mt-0" style={{ cursor: 'pointer', backgroundColor: '#c9364a', color: "#FFF", fontSize: "12px" }} >
										<IntlMessages id="ticket.source.hotsheet" />
									</li>
								</ul>
								<ul className="sub-menu">
									{authUser && (USER_TYPES.includes(authUser.type) || isDealerPermissionTicketShowroomView(authUser)) && (
										<li className="menu no-arrow"  >
											<NavLink to="/app/ticket/hotsheet/showroom">
												<i className="zmdi zmdi-car zmdi-hc-fw" />
												<span className="nav-text">
													<IntlMessages id="ticket.type.showroom" />
												</span>
											</NavLink>
										</li>
									)}
									{authUser && (USER_TYPES.includes(authUser.type)) && (
										<li className="menu no-arrow">
											<NavLink to="/app/ticket/hotsheet/report/status/showroom">
												<i className="zmdi zmdi-file-text zmdi-hc-fw" />
												<span className="nav-text">
													<IntlMessages id="ticket.report.status.type.showroom" />
												</span>
											</NavLink>
										</li>
									)}

									{authUser && (USER_TYPES.includes(authUser.type) || isDealerPermissionTicketServiceView(authUser)) && (
										<li className="menu no-arrow">
											<NavLink to="/app/ticket/hotsheet/service">
												<i className="zmdi zmdi-settings zmdi-hc-fw" />
												<span className="nav-text">
													<IntlMessages id="ticket.type.service" />
												</span>
											</NavLink>
										</li>
									)}
									{authUser && (USER_TYPES.includes(authUser.type)) && (
										<li className="menu no-arrow">
											<NavLink to="/app/ticket/hotsheet/report/status/service">
												<i className="zmdi zmdi-file-text zmdi-hc-fw" />
												<span className="nav-text">
													<IntlMessages id="ticket.report.status.type.service" />
												</span>
											</NavLink>
										</li>
									)}
								</ul>
							</li>
						</ul>
					)}
				{authUser &&
					(USER_TYPES.includes(authUser.type) ||
						CALLCENTER_TYPES.includes(authUser.type) ||
						AREA_MANAGER_TYPES.includes(authUser.type) ||
						isDealerPermissionTicketShowroomView(authUser) ||
						isDealerPermissionTicketServiceView(authUser)) && (
						<ul className="nav-menu" style={{ backgroundColor: "#313131" }} >
							<li className="menu">
								<ul>
									<li className="nav-header mt-0" style={{ cursor: 'pointer', backgroundColor: '#c84758', color: "#FFF", fontSize: "12px" }} >
										<IntlMessages id="ticket.source.callcenter" />
									</li>
								</ul>
								<ul className="sub-menu">
									{authUser && (USER_TYPES.includes(authUser.type) || isDealerPermissionTicketShowroomView(authUser) ||
										CALLCENTER_TYPES.includes(authUser.type) || (AREA_MANAGER_TYPES.includes(authUser.type) && authUser.group.showroom)
									) && (
											<li className="menu no-arrow">
												<NavLink to="/app/ticket/callcenter/showroom">
													<i className="zmdi zmdi-car zmdi-hc-fw" />
													<span className="nav-text">
														<IntlMessages id="ticket.type.showroom" />
													</span>
												</NavLink>
											</li>
										)}
									{authUser && (USER_TYPES.includes(authUser.type) || (AREA_MANAGER_TYPES.includes(authUser.type) && authUser.group.showroom)) && (
										<li className="menu no-arrow">
											<NavLink to="/app/ticket/callcenter/report/status/showroom">
												<i className="zmdi zmdi-file-text zmdi-hc-fw" />
												<span className="nav-text">
													<IntlMessages id="ticket.report.status.type.showroom" />
												</span>
											</NavLink>
										</li>
									)}
									{authUser && (USER_TYPES.includes(authUser.type) || isDealerPermissionTicketServiceView(authUser) ||
										CALLCENTER_TYPES.includes(authUser.type) || (AREA_MANAGER_TYPES.includes(authUser.type) && authUser.group.service)
									) && (
											<li className="menu no-arrow">
												<NavLink to="/app/ticket/callcenter/service">
													<i className="zmdi zmdi-settings zmdi-hc-fw" />
													<span className="nav-text">
														<IntlMessages id="ticket.type.service" />
													</span>
												</NavLink>
											</li>
										)}
									{authUser && (USER_TYPES.includes(authUser.type) || (AREA_MANAGER_TYPES.includes(authUser.type) && authUser.group.service)) && (
										<li className="menu no-arrow">
											<NavLink to="/app/ticket/callcenter/report/status/service">
												<i className="zmdi zmdi-file-text zmdi-hc-fw" />
												<span className="nav-text">
													<IntlMessages id="ticket.report.status.type.service" />
												</span>
											</NavLink>
										</li>
									)}
								</ul>
							</li>
						</ul>
					)}

				{authUser &&
					(USER_TYPES.includes(authUser.type) ||
						AREA_MANAGER_TYPES.includes(authUser.type) ||
						isDealerPermissionGeneralReport(authUser) ||
						isDealerPermissionManagementReport(authUser)) && (
						<ul className="nav-menu" style={{ backgroundColor: "#414141" }} >
							<li className="menu">
								<ul>
									<li className="nav-header mt-0" style={{ cursor: 'pointer', backgroundColor: '#c75665', color: "#FFF", fontSize: "12px" }} >
										<IntlMessages id="report" />
									</li>
								</ul>
								<ul className="sub-menu">
									{(USER_TYPES.includes(authUser.type) || AREA_MANAGER_TYPES.includes(authUser.type) ||
										isDealerPermissionGeneralReport(authUser) || isDealerPermissionManagementReport(authUser)
									) && (
											<li className="menu no-arrow">
												<NavLink to="/app/report/quickvoc">
													<i className="zmdi zmdi-file-text zmdi-hc-fw" />
													<span className="nav-text">
														<IntlMessages id="report.quickvoc" />
													</span>
												</NavLink>
											</li>
										)}
									{(USER_TYPES.includes(authUser.type) || AREA_MANAGER_TYPES.includes(authUser.type) ||
										isDealerPermissionGeneralReport(authUser) || isDealerPermissionManagementReport(authUser)
									) && (
											<li className="menu no-arrow">
												<NavLink to="/app/report/ticketkpi">
													<i className="zmdi zmdi-file-text zmdi-hc-fw" />
													<span className="nav-text">
														<IntlMessages id="report.ticket.kpi" />
													</span>
												</NavLink>
											</li>
										)}
									{(USER_TYPES.includes(authUser.type) || (AREA_MANAGER_TYPES.includes(authUser.type) && authUser.group.showroom)) && (
										<li className="menu no-arrow">
											<NavLink to="/app/report/salevoc">
												<i className="zmdi zmdi-file-text zmdi-hc-fw" />
												<span className="nav-text">
													<IntlMessages id="report.salevoc" />
												</span>
											</NavLink>
										</li>
									)}
									{(USER_TYPES.includes(authUser.type) || (AREA_MANAGER_TYPES.includes(authUser.type) && authUser.group.showroom)) && (
										<li className="menu no-arrow">
											<NavLink to="/app/report/salevocentity">
												<i className="zmdi zmdi-file-text zmdi-hc-fw" />
												<span className="nav-text">
													<IntlMessages id="report.salevocentity" />
												</span>
											</NavLink>
										</li>
									)}
									{(USER_TYPES.includes(authUser.type) && !NML_TYPES.includes(authUser.type)) && (
										<li className="menu no-arrow">
											<NavLink to="/app/report/salevockpi">
												<i className="zmdi zmdi-file-text zmdi-hc-fw" />
												<span className="nav-text">
													<IntlMessages id="report.salevockpi" />
												</span>
											</NavLink>
										</li>
									)}
									{(USER_TYPES.includes(authUser.type) || (AREA_MANAGER_TYPES.includes(authUser.type) && authUser.group.service)) && (
										<li className="menu no-arrow">
											<NavLink to="/app/report/servicevoc">
												<i className="zmdi zmdi-file-text zmdi-hc-fw" />
												<span className="nav-text">
													<IntlMessages id="report.servicevoc" />
												</span>
											</NavLink>
										</li>
									)}
									{(USER_TYPES.includes(authUser.type) || (AREA_MANAGER_TYPES.includes(authUser.type) && authUser.group.service)) && (
										<li className="menu no-arrow">
											<NavLink to="/app/report/servicevocentity">
												<i className="zmdi zmdi-file-text zmdi-hc-fw" />
												<span className="nav-text">
													<IntlMessages id="report.servicevocentity" />
												</span>
											</NavLink>
										</li>
									)}
									{(USER_TYPES.includes(authUser.type) && !NML_TYPES.includes(authUser.type)) && (
										<li className="menu no-arrow">
											<NavLink to="/app/report/servicevockpi">
												<i className="zmdi zmdi-file-text zmdi-hc-fw" />
												<span className="nav-text">
													<IntlMessages id="report.servicevockpi" />
												</span>
											</NavLink>
										</li>
									)}
									{(USER_TYPES.includes(authUser.type) && !NML_TYPES.includes(authUser.type)) && (
										<li className="menu no-arrow">
											<NavLink to="/app/report/hotsheet/showroom">
												<i className="zmdi zmdi-file-text zmdi-hc-fw" />
												<span className="nav-text">
													<IntlMessages id="report.hotsheet.caseclosed.showroom" />
												</span>
											</NavLink>
										</li>
									)}
									{(USER_TYPES.includes(authUser.type) && !NML_TYPES.includes(authUser.type)) && (
										<li className="menu no-arrow">
											<NavLink to="/app/report/hotsheet/service">
												<i className="zmdi zmdi-file-text zmdi-hc-fw" />
												<span className="nav-text">
													<IntlMessages id="report.hotsheet.caseclosed.service" />
												</span>
											</NavLink>
										</li>
									)}
									{(USER_TYPES.includes(authUser.type) && !NML_TYPES.includes(authUser.type)) && (
										<li className="menu no-arrow">
											<NavLink to="/app/report/pdca/showroom">
												<i className="zmdi zmdi-file-text zmdi-hc-fw" />
												<span className="nav-text">
													<IntlMessages id="report.pdca.showroom" />
												</span>
											</NavLink>
										</li>
									)}
									{(USER_TYPES.includes(authUser.type) && !NML_TYPES.includes(authUser.type)) && (
										<li className="menu no-arrow">
											<NavLink to="/app/report/pdca/service">
												<i className="zmdi zmdi-file-text zmdi-hc-fw" />
												<span className="nav-text">
													<IntlMessages id="report.pdca.service" />
												</span>
											</NavLink>
										</li>
									)}
									{(USER_TYPES.includes(authUser.type) && !NML_TYPES.includes(authUser.type)) && (
										<li className="menu no-arrow">
											<NavLink to="/app/report/notify/showroom">
												<i className="zmdi zmdi-file-text zmdi-hc-fw" />
												<span className="nav-text">
													<IntlMessages id="report.notify.showroom" />
												</span>
											</NavLink>
										</li>
									)}
									{(USER_TYPES.includes(authUser.type) && !NML_TYPES.includes(authUser.type)) && (
										<li className="menu no-arrow">
											<NavLink to="/app/report/notify/service">
												<i className="zmdi zmdi-file-text zmdi-hc-fw" />
												<span className="nav-text">
													<IntlMessages id="report.notify.service" />
												</span>
											</NavLink>
										</li>
									)}
									{(USER_TYPES.includes(authUser.type) && !NML_TYPES.includes(authUser.type)) && (
										<li className="menu no-arrow">
											<NavLink to="/app/dealer">
												<i className="zmdi zmdi-store zmdi-hc-fw" />
												<span className="nav-text">
													<IntlMessages id="dealer" />
												</span>
											</NavLink>
										</li>
									)}
								</ul>
							</li>
						</ul>
					)}


				{authUser && authUser.type == "csn" && (
					<ul className="nav-menu">
						<li className="nav-header mt-0" style={{ backgroundColor: '#c61633', color: "#FFF", fontSize: "12px" }} >
							<IntlMessages id="setting" />
						</li>
						{false && (
							<li className="menu no-arrow">
								<NavLink to="/app/ticket/hotsheet/import">
									<i className="zmdi zmdi-file zmdi-hc-fw" />
									<span className="nav-text">
										<IntlMessages id="ticket.source.hotsheet.import" />
									</span>
								</NavLink>
							</li>
						)}
						<li className="menu no-arrow">
							<NavLink to="/app/user">
								<i className="zmdi zmdi-account zmdi-hc-fw" />
								<span className="nav-text">
									<IntlMessages id="user" />
								</span>
							</NavLink>
						</li>
					</ul>
				)}

			</CustomScrollbars>
		);
	}
}

const mapStateToProps = ({ auth: { authUser } }) => {
	return { authUser };
};

export default withRouter(
	connect(
		mapStateToProps,
		{}
	)(SidenavContent)
);
